import { render } from "./vtradedetailed.vue?vue&type=template&id=f95b11f4&scoped=true"
import script from "./vtradedetailed.vue?vue&type=script&lang=js"
export * from "./vtradedetailed.vue?vue&type=script&lang=js"

import "./vtradedetailed.vue?vue&type=style&index=0&id=f95b11f4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95b11f4"]])

export default __exports__